import { lazy } from 'react';

const HomeContent = lazy(() => import('../components/BumperNavMenu/HomeContent'));
const LocationsContent = lazy(() => import('../components/BumperNavMenu/LocationsContent'));
const RatesContent = lazy(() => import('../components/BumperNavMenu/RatesContent'));
const PMPartnersContent = lazy(() => import('../components/BumperNavMenu/PMPartnersContent'));
const AboutContent = lazy(() => import('../components/BumperNavMenu/AboutContent'));

export const contentMap = {
  home: HomeContent,
  locations: LocationsContent,
  rates: RatesContent,
  ...(process.env.REACT_APP_DISABLE_FEATURE !== 'true' ? { pm_partners: PMPartnersContent } : {}),
  about: AboutContent,
};
